<template>
  <v-container text-center grid-list-lg>
    <v-snackbar
      v-model="snackbar"
      color="error"
      top
      xs12
      :multi-line="true"
      :timeout="10000"
    >
      {{error}}
    </v-snackbar>
    <v-snackbar
      v-model="successSnack"
      color="success"
      top
      xs12
      :multi-line="true"
      :timeout="10000"
    >
      This product is now deleted
    </v-snackbar>
    <v-dialog
      v-model='deleteShow'
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{$t('global.areYouSure')}}</v-card-title>
        <v-card-text>{{$t('products.areYouSure')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="deleteId = null"
          > {{$t('global.cancel')}} </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="deleteProduct()"
          > {{$t('global.delete')}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout justify-space-around row wrap>
      <v-flex
        v-for="(product, index) in products"
        :key="index" xs12 sm6 md4 lg3
      >
        <v-card height="100%" text tile>
          <v-img
            height="150px"
            contain
            :src='(product.packshotURLs.length >= 1 ? product.packshotURLs[0].ipad : "")'
            :lazy-src='(product.packshotURLs.length >= 1 ? product.packshotURLs[0].ipad : "")'
          >
            <v-container  v-if="product.packshotURLs.length < 1" bg fill-height grid-list-md text-center>
              <v-layout row wrap align-center>
                <v-flex>
                  <v-icon x-large>broken_image</v-icon>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-flex>
              <h3 class="mb-0">{{product.title['en-US']}}</h3>
              {{product.subtitle['en-US']}}
          </v-flex>
          <v-layout justify-space-around align-end>
          <v-card-actions>
            <v-spacer/>
            <v-btn icon v-on:click.stop="$router.push('/product/' + product.id)">
              <v-icon class="transparent grey--text">
                edit
              </v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon class="transparent grey--text" @click="deleteId = product.id">
                delete_forever
              </v-icon>
            </v-btn>
            <v-spacer/>
          </v-card-actions>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import axios from 'axios'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev

axios.defaults.baseURL = apiUrl
var instance = axios.create({
  headers: { 'Authorization': 'Bearer ' + localStorage.token }
}); export default {
  props: ['products'],
  components: {
  },
  data () {
    return {
      deleteId: '',
      snackbar: false,
      successSnack: false,
      error: 'Error'
    }
  },
  methods: {
    deleteProduct: function () {
      instance.delete('/' + this.$session.get('brand') + '/product/' + this.deleteId)
        .then(() => { this.deleteId = null; this.$emit('reload'); this.successSnack = true })
        .catch(() => {
          this.snackbar = true
          this.error = "The suppression of this catalog failed, try again later"
        })
    }
  },
  computed: {
    deleteShow: function () {
      return !!this.deleteId
    }
  }
}
</script>
<style scoped>
.v-lazy-image {
  transition: filter 0.7s;
  margin-top: 20px;
  height: 150px;
}
.v-lazy-image-loaded {
  filter: blur(0);
}

</style>
